import { Box } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import AddButtonRounded from '@Components/AddButtonRounded';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { useDisclosure } from '@hooks/useDisclosure';
import ExportIncomeModal from '../ExportIncomeModal/ExportIncomeModal';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

const ExportIncomeAddButton = () => {
  const [opened, { open, close }] = useDisclosure();
  const { watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <Flex gap={1} mt={2}>
        <Box width={1} minWidth={235} maxWidth={350} />
        <Box
          ml={1}
          width={1}
          display={'grid'}
          gridTemplateColumns={'1fr'}
          gap={3}
        >
          <AddButtonRounded
            name="แจกแจงรายได้จากต่างประเทศ"
            onClick={open}
            disabled={isCompletedTh || isCompletedEn}
          />
        </Box>
      </Flex>
      {opened && (
        <ExportIncomeModal mode="create" open={opened} close={close} />
      )}
    </>
  );
};

export default ExportIncomeAddButton;
